import { Box, ITheme, Typography, useTheme } from '@mui/material';
import { darken, lighten } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StageDistribution } from '../../models/Common';

export interface IStageDistributionGraph{
    data : StageDistribution;
}

const StageDistributionGraph: React.FC<IStageDistributionGraph> = ({ data }) => {
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();

    const earlyRadius = data.growth === 0 && data.late === 0 ? "4px" : "4px 0 0 4px";
    const growthRadius = data.early === 0 && data.late === 0 ? "4px" : (data.early === 0 ? "4px 0 0 4px" : (data.late === 0 ? "0 4px 4px 0" : undefined));
    const lateRadius = data.growth === 0 && data.early === 0 ? "4px" : "0 4px 4px 0";

    return <Box display={"flex"} width={"100%"} gap={"1px"}>
        {data.early > 0 &&<Box display={'flex'} flexDirection={"column"} flexGrow={Math.floor(data.early*100)} gap={"7px"}>
            <Typography fontSize={"14px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone4}>{Math.floor(data.early*100)}%</Typography>
            <Box width={"100%"} height={"8px"}  sx={{ background: `linear-gradient(90deg, ${lighten(theme.palette.primary.dark, 0.4)} 0%, ${lighten(theme.palette.primary.dark, 0.2)} 100%)`}} borderRadius={earlyRadius} />
            <Typography fontSize={"10px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone3}>{t('PortfolioPageItemStageEarly')}</Typography>
        </Box>}
        {data.growth > 0 &&<Box display={'flex'} flexDirection={"column"} flexGrow={Math.floor(data.growth*100)} gap={"7px"}>
            <Typography fontSize={"14px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone4}>{Math.floor(data.growth*100)}%</Typography>
            <Box width={"100%"} height={"8px"} sx={{ background: `linear-gradient(90deg, ${lighten(theme.palette.primary.dark, 0.2)} 0%, ${darken(theme.palette.primary.dark, 0.2)} 100%)`}} borderRadius={growthRadius} />
            <Typography fontSize={"10px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone3}>{t('PortfolioPageItemStageGrowth')}</Typography>
        </Box>}
        {data.late > 0 &&<Box display={'flex'} flexDirection={"column"} flexGrow={Math.floor(data.late*100)} gap={"7px"}>
            <Typography fontSize={"14px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone4}>{Math.floor(data.late*100)}%</Typography>
            <Box width={"100%"} height={"8px"} sx={{ background: `linear-gradient(90deg, ${darken(theme.palette.primary.dark, 0.2)} 0%, ${darken(theme.palette.primary.dark, 0.4)} 100%)`}} borderRadius={lateRadius} />
            <Typography fontSize={"10px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone3}>{t('PortfolioPageItemStageLate')}</Typography>
        </Box>}
    </Box>;

}
export default StageDistributionGraph;